module.exports = __webpack_public_path__ + "img/icon2.986620c6.png";